// third-party
import { FormattedMessage } from 'react-intl';

// assets
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

import type { MetricTabEntry } from 'model/types/data-analytics';

import { METRIC_TABS } from 'features/data-analytics/constants/metricTabs';
import { isMetricTabVisible } from 'features/data-analytics/utils/isMetricTabVisible';

// icons
const icons = { BarChartOutlined };

// ==============================|| MENU ITEMS - DATA ANALYTICS ||============================== //

function buildDataAnalyticsGroup(tabs: MetricTabEntry[]): NavItemType {
  return {
    id: 'data-analytics-menu',
    type: 'group',
    children: [
      {
        id: 'data-analytics',
        title: <FormattedMessage id="data-analytics" />,
        type: 'collapse',
        icon: icons.BarChartOutlined,
        defaultOpen: false,
        children: tabs.map(({ labelId, path }) => ({
          id: `data-analytics-${path.split('/').pop()}`,
          title: <FormattedMessage id={labelId} />,
          type: 'item',
          url: path
        }))
      }
    ]
  };
}

export function dataAnalyticsForFlags(flags: string[]): NavItemType {
  return buildDataAnalyticsGroup(METRIC_TABS.filter((tab) => isMetricTabVisible(tab, flags)));
}

const dataAnalytics: NavItemType = buildDataAnalyticsGroup(METRIC_TABS);

export default dataAnalytics;
